import template from './provider-status-header.html';
import './provider-status-header.scss';
import _ from 'lodash';

export const PROVIDER_STATUS_AVAILABLE = 'available';
export const PROVIDER_STATUS_ON_CALL = 'video';

class ProviderStatusModel {
  constructor(title, className) {
    this.title = title;
    this.className = className;
  }
}

export default angular
  .module('doxy.provider.statusHeader', [])
  .component('providerStatusHeader', {
    template,
    controller($rootScope, $timeout, $translate, pn, currentUserHelper) {
      this.doctors = [];
      this.availableProvidersCount = null;
      this.currentStatus = null;
      this.currentInstitution = currentUserHelper.institution.id;

      this.providersAvailableStatus = (providersCount) => {
        if (providersCount === 1) {
          return new ProviderStatusModel(
            $translate.instant('provider.check-in-status.available', {
              providersCount,
            }),
            'provider-status-header__data--available'
          );
        } else {
          return new ProviderStatusModel(
            $translate.instant('provider.check-in-status.multiple-available', {
              providersCount,
            }),
            'provider-status-header__data--available'
          );
        }
      };

      this.providersOnCallStatus = new ProviderStatusModel(
        $translate.instant('provider.check-in-status.multiple-on-call'),
        'provider-status-header__data--on-call'
      );

      this.providersOfflineStatus = new ProviderStatusModel(
        $translate.instant('provider.status.multiple-offline--full'),
        'provider-status-header__data--offline'
      );

      this.providerAvailableStatus = new ProviderStatusModel(
        $translate.instant('provider.status.available--full'),
        'provider-status-header__data--available provider-status-header__data--free'
      );

      this.providerOnCallStatus = new ProviderStatusModel(
        $translate.instant('provider.status.on-call--full'),
        'provider-status-header__data--on-call provider-status-header__data--free'
      );

      this.providerOfflineStatus = new ProviderStatusModel(
        $translate.instant('provider.status.offline--full'),
        'provider-status-header__data--offline provider-status-header__data--free'
      );

      this.isClinicAccount = () => {
        return !!currentUserHelper.institution.id;
      };

      this.getAvailableDoctorsCount = () => {
        return _.filter(this.doctors, (doctor) => {
          return doctor.state.status === PROVIDER_STATUS_AVAILABLE;
        }).length;
      };

      this.updateCurrentStatusForFreePro = () => {
        switch (this.doctors[0].state.status) {
          case PROVIDER_STATUS_AVAILABLE:
            this.currentStatus = this.providerAvailableStatus;
            break;
          case PROVIDER_STATUS_ON_CALL:
            this.currentStatus = this.providerOnCallStatus;
            break;
          default:
            this.currentStatus = this.providerOfflineStatus;
        }
      };

      this.updateCurrentStatusForClinic = () => {
        let providersCount = this.getAvailableDoctorsCount();
        if (providersCount >= 1) {
          this.currentStatus = this.providersAvailableStatus(providersCount);
        } else if (providersCount === 0) {
          this.currentStatus = this.providersOnCallStatus;
        } else {
          this.currentStatus = this.providersOfflineStatus;
        }
      };

      this._initProviderStatus = () => {
        if (this.isClinicAccount()) {
          if (this.doctors.length === 0) {
            this.currentStatus = this.providersOfflineStatus;
            return;
          }
          this.updateCurrentStatusForClinic();
        } else {
          if (this.doctors.length === 0) {
            this.currentStatus = this.providerOfflineStatus;
            return;
          }
          this.updateCurrentStatusForFreePro();
        }
      };

      const updateAvailableProviders = () => {
        this.doctors = pn.people.getUniqDoctors();
        this.doctors.forEach((doctor) => {
          doctor.addListenerIfNotExists(
            'stateUpdate:status',
            this._initProviderStatus
          );
        });
        this._initProviderStatus();
      };

      const activate = () => {
        updateAvailableProviders();
        pn.on('join', updateAvailableProviders);
        pn.on('leave', updateAvailableProviders);
      };

      this.$onInit = () => {
        pn.connected ? activate() : pn.once('connected', activate);
      };
    },
  }).name;
